import { Injectable, Injector } from '@angular/core';

import { DialogService, MediaScreenService, UaParserService } from '@pu/services';

import { GlobalSearchOverlay } from './global-search-overlay';

@Injectable()
export class GlobalSearchDialogService extends DialogService {
  constructor(
    _overlay: GlobalSearchOverlay,
    _injector: Injector,
    _mediaScreenService: MediaScreenService,
    _uaParserService: UaParserService,
  ) {
    super(_overlay, _injector, _mediaScreenService, _uaParserService);
  }
}
